@for (project of projects(); track $index) {
  <button class="responsive-pill-button"
          [routerLink]="['/', SIGN_PATH, project.id]"
          matButton="filled">
    @if (project.ownerId !== userId()) {
      <mat-icon>share</mat-icon>
    } @else {
      <mat-icon>business_center</mat-icon>
    }
    <span class="truncate-text"><strong>{{ project.ownerName }}</strong></span>
    <span class="truncate-text">{{ project.projectName }}</span>
  </button>
} @empty {
  <div class="no-latest-projects">
    <div>Här var det tomt!</div>
    <p>I denna lista dyker de senaste projekten du arbetat med upp.</p>
  </div>
}
